/* @flow */
import React from "react";
import styled, { css } from "styled-components";
import { Link } from "../common/Link";
import { fontSize } from "../common/styled-mixins";

const Button = styled.button`
  position: relative;
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: center;
  flex-shrink: 0;
  height: 31px;
  width: auto;
  padding: 0 18px;
  font-weight: 400;
  font-size: ${fontSize(14)};
  line-height: 1;
  white-space: nowrap;
  text-align: center;
  border: none;
  border-radius: 3px;
  color: #fff;
  text-decoration: none;
  transition: all 0.3s ease;
  cursor: pointer;

  hover,
  :active,
  :focus {
    color: #fff;
    text-decoration: none;
  }

  ${props =>
    props.type === "refill" &&
    css`
      background-color: #60a31c;

      :hover,
      :active,
      :focus {
        background-color: #427f03;
      }
    `};
  ${props =>
    props.type === "withdraw" &&
    css`
      background-color: #97959a;
      margin-left: 12px;

      :hover,
      :active,
      :focus {
        background-color: #756886;
      }
    `};
  ${props =>
    props.type === "trade" &&
    css`
      color: #ffffff;
      background-color: ${props => props.theme.accent};

      :hover,
      :active,
      :focus {
        color: #362f41;
        background-color: #eb8a00;
      }

      ${process.env.REACT_APP_DEPLOY_TARGET === "irontrade" &&
        css`
          position: relative;
          font-size: ${fontSize(12)};
          font-weight: bold;
          color: #ffffff;
          text-decoration: none;
          text-transform: uppercase;
          background-image: linear-gradient(to left, #47c0c8 0%, #5c6cc0 100%);
          border-radius: 32px;
          cursor: pointer;
          z-index: 2;

          ::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            display: block;
            background-image: linear-gradient(
              to left,
              #5c6cc0 0%,
              #47c0c8 100%
            );
            border-radius: inherit;
            z-index: -1;
            opacity: 0;
            transition: opacity 0.5s;
          }

          :hover {
            color: #ffffff;
            ::before {
              opacity: 1;
            }
          }
        `};
    `};

  ${({ type, theme }) =>
  process.env.REACT_APP_DEPLOY_TARGET === "irontrade" &&
    (type === "withdraw" || type === "refill" || type === "tradeCardRefill") &&
    css`
      font-size: ${fontSize(12)};
      font-weight: bold;
      color: ${theme.mode === "light" && type !== "tradeCardRefill"
        ? "#3B9478"
        : "#ffffff"};
      text-decoration: none;
      text-transform: uppercase;
      background: none;
      border: 2px solid
        ${theme.mode === "light" && type !== "tradeCardRefill"
          ? "#3B9478"
          : "#ffffff"};
      border-radius: 32px;
      cursor: pointer;
      transition: all 0.5s;

      :hover {
        color: ${theme.mode === "light" && type !== "tradeCardRefill"
          ? "#ffffff"
          : "#3B9478"};
        background-color: ${theme.mode === "light" && type !== "tradeCardRefill"
          ? "#3B9478"
          : "#ffffff"};
      }
    `};

  ${props =>
    props.mobile &&
    css`
      min-height: 58px;
      font-weight: 700;
      font-size: 24px;
      text-shadow: -1px -1px #ca7700;
      background-color: #fea600;
      background: linear-gradient(to bottom, #fea600, #fd9600);
      box-shadow: inset 0px -1px 0px 0px #fea600;
      border-bottom: 2px solid #ca7700;
      border-radius: 8px;
      color: #fff;

      :hover,
      :active,
      :focus {
        background-color: #fd9600;
        background: linear-gradient(to bottom, #fd9600, #fea600);
      }
    `};
`;

type Props = {
  type: "refill" | "withdraw" | "trade",
  to?: string
};

const AccountButton = ({ type, ...props }: Props) => (
  <Button as={props.to != null ? Link : Button} type={type} {...props} />
);

export default AccountButton;



// WEBPACK FOOTER //
// ./src/components/AccountType/AccountButton.js